<template>
  <div style="padding:100px 8%;">
    <div>
      <h4>保險給付歸類</h4>
      <div class="text-right">
        <button
          type="button"
          class="btn btn-default btn-lg w-200 fw-600"
          @click="panelOpen('insuranceBenefitAddModalOpen')"
        >
          新增保險給付歸類
        </button>
      </div>
      <section class="row"   :class="{'section-loading': isLoading}">
        <table class="table datatable">
          <thead>
            <tr>
              <th style="width:20%" class="text-center"></th>
              <th style="width:20%" class="text-center">給付歸類</th>
              <th style="width:60%" class="text-center">給付歸類說明</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(data, i) in categoryList" :key="`tradition-data-${i}`">
              <td class="text-center" v-if="data.editMode">
                <button
                  type="button"
                  class="btn btn-primary btn-sm"
                  @click="doEdit(data)"
                >
                  更新
                </button>
                <button
                  type="button"
                  class="btn btn-default btn-sm"
                  @click="exitEditMode(data)"
                >
                  取消
                </button>
              </td>
              <td class="text-center" v-else>
                <button
                  type="button"
                  class="btn btn-primary btn-sm"
                  :disabled="isEdit"
                  @click="openEditMode(data)"
                >
                  編輯
                </button>
                <button
                  type="button"
                  class="btn btn-default btn-sm"
                  :disabled="isEdit"
                  @click="removeCategory(data)"
                >
                  刪除
                </button>
              </td>
              <td class="text-center">{{data.categoryNum}}</td>
              <td v-if="data.editMode" class="text-center">
                <input
                  type="text"
                  maxlength="20"
                  data-vv-as="給付歸類說明"
                  :data-vv-name="`categoryName-${data.categoryNum}`"
                  placeholder="給付歸類說明"
                  v-validate="'required'"
                  class="form-control form-control-inline"
                  v-model="data.categoryName"
                  :class="{ 'is-invalid': errors.has(`categoryName-${data.categoryNum}`) || isCategoryNameExist }"
                  @input="data.categoryName = data.categoryName.trim()"
                  @blur="data.categoryName = data.categoryName.trim()"
                />
              </td>
              <td v-else class="text-center">{{data.categoryName}}</td>
            </tr>
          </tbody>
        </table>
      </section>
    </div>

    <Insurance-Benefit-Add-Modal
      :open="insuranceBenefitAddModalOpen"
      :categoryList="categoryList"
      @close="insuranceBenefitAddModalClose"
      @cancel="panelClose('insuranceBenefitAddModalOpen')"
    />

  </div>
</template>

<script>
import InsuranceBenefitAddModal from "./components/InsuranceBenefitAddModal";
import { commonMixin } from "@/mixins/common";
import {
  queryCoverageCategoryMain,
  updateCoverageCategoryMain,
  deleteCoverageCategoryMain,
} from "@/service";
export default {
  name: "InsuranceBenefit",
  mixins: [commonMixin],
  data() {
    return {
      categoryList: [],
      insuranceBenefitAddModalOpen: false,
      isCategoryNameExist: false,
      isLoading: false,
      isEdit: false,
    };
  },
  components: {
    InsuranceBenefitAddModal,
  },
  methods: {
    init() {
      this.categoryList = [];
      this.isLoading = true;
      queryCoverageCategoryMain(this.$store.state.userInfo.id).then(
        (result) => {
          if (result.header && result.header.status == "200") {
            result.data.forEach((item) => {
              let categoryData = {
                categoryId: item.coveragecategoryid,
                categoryNum: item.sequencenumber,
                categoryName: item.name,
                editMode: false,
              };
              this.categoryList.push(categoryData);
            });
          } else {
            this.$toast.info({ title: result.header.message });
          }
          this.isLoading = false;
        }
      );
    },
    openEditMode(data) {
      this.isEdit = true;
      data.editMode = !data.editMode;
      data.originCategoryName = data.categoryName;
    },
    exitEditMode(data) {
      this.isEdit = false;
      data.editMode = !data.editMode;
      data.categoryName = data.originCategoryName;
    },
    removeCategory(data) {
      if (confirm("確認是否刪除！？")) {
        this.isLoading = true;
        deleteCoverageCategoryMain(this.$store.state.userInfo.id, data).then(
          (result) => {
            if (result.header && result.header.status == "200") {
              this.$toast.info({ title: "刪除成功" });
              this.init();
            } else {
              this.$toast.info({ title: result.header.message });
            }
            this.isLoading = false;
          }
        );
      }
    },
    insuranceBenefitAddModalClose() {
      this.panelClose("insuranceBenefitAddModalOpen");
      this.init();
    },
    doEdit(data) {
      //檢核
      this.isCategoryNameExist = false;
      this.$validator.validateAll().then((el) => {
        if (!el) {
          let errMsg = [];
          for (let i = 0; i < this.errors.items.length; i++) {
            errMsg.push(this.errors.items[i].msg);
          }
          let showErrMsg = [...new Set(errMsg)];
          showErrMsg.forEach((s) => {
            this.$toast.info({ title: s }); //印出檢核後的錯誤訊息
          });
          return;
        }
        this.$validator.reset();
        this.categoryList.forEach((item) => {
          if (
            data.categoryName != "" &&
            item.categoryName == data.categoryName &&
            item.categoryId != data.categoryId
          ) {
            this.isCategoryNameExist = true;
            this.$toast.info({ title: "給付歸類說明已存在" });
          }
        });
        if (this.isCategoryNameExist) {
          return;
        }
        //通過檢查

        this.isLoading = true;
        updateCoverageCategoryMain(this.$store.state.userInfo.id, data).then(
          (result) => {
            if (result.header && result.header.status == "200") {
              this.$toast.info({ title: "編輯成功" });
              this.init();
            } else {
              this.$toast.info({ title: result.header.message });
            }
            this.isLoading = false;
            this.isEdit = false;
          }
        );
      });
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style scoped>
.mt-40 {
  margin-top: 40px;
}

.ml-40 {
  margin-left: 40px;
}
.w-200 {
  width: 200;
}
.fw-600 {
  font-weight: 600;
}
</style>
